import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';


var $window = $(window);
var winW,winH,footerH,bodyH,scrollTop;
$(function() {    
    
    $('body').addClass('fade-in');
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    //menu active
    if($('main.about').length > 0){
        $('ul.mmenu > li').eq(0).addClass('active');
    }else if($('main.service').length > 0){
        $('ul.mmenu > li').eq(1).addClass('active');
    }else if($('main.team').length > 0){
        $('ul.mmenu > li').eq(2).addClass('active');
    }else if($('main.news').length > 0){
        $('ul.mmenu > li').eq(3).addClass('active');
    }else if($('main.contact').length > 0){
        $('ul.mmenu > li').eq(4).addClass('active');
    }
    //sub menu
    $('a[data-menu]').on('click',function(){
        var $this = $(this).parent();    
        if(!$this.hasClass('active')){
            $this.siblings().removeClass('active');
            $this.addClass('active');
        }else{
            $this.removeClass('active');
        }            
    });
    //mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body,html'),
    $header = $('header');

    menuicon.on('click',function(){
        var $this = $(this);
        if(!$this.hasClass('menu-expanded')){
            $this.addClass('menu-expanded');
            nav.stop().fadeIn();
            $body.css({'overflow':'hidden'}).addClass('modal_open');
        }else{
            $this.removeClass('menu-expanded');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''}).removeClass('modal_open');
        }
        return false;
    });
    
    $('.subBox a').on('click',function(){
        menuicon.removeClass('menu-expanded');
        nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        $body.css({'overflow':''}).removeClass('modal_open');
    });
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('main').css('min-height',bodyH);
        if(winW > 991){
            menuicon.parent('.headBox').removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
        resizeBgcover(winW);
    }).resize();
    var scrollTop;
    // hide menu start
    $window.on('scroll', function() {
        scrollTop = $(this).scrollTop();
        gotopfun(scrollTop);
    }).scroll();
    //faq
    $('[data-mtoggle]').on('click',function(){
        $(this).parent().siblings().find('.editor_Box').slideUp();
        $(this).parent().siblings().removeClass('active');
        $(this).next().is(':hidden') ?  $(this).next().slideDown():$(this).next().slideUp();
        $(this).parent().hasClass('active') ? $(this).parent().removeClass('active') : $(this).parent().addClass('active');
        return false;
    })
    $('#file-upload').change(function () {
        var filepath = this.value;
        var m = filepath.match(/([^\/\\]+)$/);
        var filename = m[1];
        $('#filename span.file_name').html(filename);
        $('#filename').removeClass('hide');
    });
    if($('.indx').length > 0){
        $('.slider-banner').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            appendDots:'.dots-container',
            arrows:false,
            speed:600,
            fade:true,
            autoplaySpeed:5000,
            autoplay:true,
            pauseOnHover:false,
        });
        $('.slider-partner').slick({
            slidesToShow:4,
            slidesToScroll: 1,
            speed:600,
            autoplaySpeed:3000,
            autoplay:true,
            pauseOnHover:false,
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                  }
                },{
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 2,
                    }
                  },
            ]
        });
        $('.indx-partner a.slicknext').on('click', function() {
            $('.slider-partner').slick('slickNext');
            return false;
        });
        $('.indx-partner a.slickprev').on('click', function() {
            $('.slider-partner').slick('slickPrev');
            return false;
        });
    }
    

});

